import { useAppContext } from '../../Services/AppContext';

export default function CaseChatEntryFileInfected() {
	const { translation } = useAppContext();

	return (
		<div className='d-flex document-item__infected'>
			<div className='flex-row align-items-center justify-content-center'>
				<div className='text-center'>
					<i className='fa fa-2x fa-exclamation'></i>
				</div>
				<div className='document-item__infected__title'>
					{translation['base.shared.fileDidntPassAntivirus']}
				</div>
			</div>
		</div>
	);
}
